<template>
  <div class="container">
    <Search />
    <div class="placeholder" />
    <div class="top-banner">
      <div class="top-banner-mask">
        <div class="content">
          <div class="content-header">
            <span>优秀品牌供应商火热招募中</span>
          </div>
          <p class="platform-name">浪潮智能终端优选</p>
          <p class="platform-intro">成就品质商家</p>
          <el-button class="apply-btn" @click="changeHash('form')">申请入驻</el-button>
        </div>
      </div>
    </div>
    <!-- 入驻流程 -->
    <div class="module">
      <span class="title">入驻流程</span>
      <div class="icon" />
      <div class="process-content">
        <template v-for="(item, index) in processList">
          <div :key="index" class="item">
            <div class="img-container">
              <img class="item-img" :src="item.pic" alt="">
            </div>
            <span class="item-text">{{ item.text }}</span>
          </div>
          <div v-if="index < 4" :key="item.pic" class="arrow" />
        </template>
      </div>
    </div>
    <!-- 招募规则 -->
    <div class="module">
      <span class="title">招募规则</span>
      <div class="icon" />
      <div class="rules-content">
        <div class="rules-item">
          <div class="rule-title">基本要求</div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">拥有大陆实体公司</span>
          </div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">仅限企业商户，不接受个体工商户</span>
          </div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">公司注册资本50万人民币及以上</span>
          </div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">公司依法成立一年及以上</span>
          </div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">公司需具备一般纳税人资格</span>
          </div>
          <div class="background-img">
            <img :src="ruleBackgroundImg" alt="">
          </div>
        </div>
        <div class="rules-item">
          <div class="rule-title">资质要求</div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">拥有正规的企业法人身份</span>
          </div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">拥有商标注册证或商标注册受理通知书</span>
          </div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">拥有商标使用授权书</span>
          </div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">特殊商品需要相关的行政许可文件</span>
          </div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">产品质量合格证明</span>
          </div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">以上资质需真实有效，并加盖相应公章</span>
          </div>
          <div class="background-img">
            <img :src="ruleBackgroundImg" alt="">
          </div>
        </div>
        <div class="rules-item">
          <div class="rule-title">招募原则</div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">公平、公正，双方资源</span>
          </div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">独家入驻原则</span>
          </div>
          <div class="rule-row">
            <div class="dot" />
            <span class="text">品牌方优先合作原则</span>
          </div>
          <div class="background-img">
            <img :src="ruleBackgroundImg" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- 平台优势 -->
    <div class="module">
      <span class="title">平台优势</span>
      <div class="icon" />
      <div id="main">
        <img :src="platformAdvantageImg" alt="">
      </div>
    </div>
    <!-- 申请入驻 -->
    <div class="module">
      <span id="form" class="title">申请入驻</span>
      <div class="icon" />
      <div class="form-content">
        <el-form ref="form" class="form-box" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="供应商名称" prop="supplierName">
            <el-input v-model="form.supplierName" maxlength="20" placeholder="请输入供应商名称" size="small" />
          </el-form-item>
          <el-form-item label="经营分类" prop="operationType">
            <el-input v-model="form.operationType" maxlength="30" placeholder="请输入经营分类" size="small" />
          </el-form-item>
          <el-form-item label="联系人" prop="name">
            <el-input v-model="form.name" maxlength="20" placeholder="请输入联系人" size="small" />
          </el-form-item>
          <el-form-item class="position-item" label="职位" prop="position">
            <el-input v-model="form.position" maxlength="20" placeholder="请输入职位" size="small" />
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="form.phone" maxlength="20" placeholder="请输入联系电话" size="small" @input="phoneInput" />
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="form.email" maxlength="30" placeholder="请输入电子邮箱（用于接收申请进度相关通知）" size="small" />
          </el-form-item>
          <el-form-item label="图形验证码" prop="captcha">
            <div class="captcha-container">
              <el-input
                v-model="form.captcha"
                placeholder="请输入右侧验证码"
                maxlength="5"
                size="medium"
                clearable
              />
              <img class="box-captcha" :src="base64" @click="getCodeImg">
            </div>
          </el-form-item>
        </el-form>
        <el-button v-no-more-click class="submit-btn" @click="submitForm">申请入驻</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
import { supplierJoinApi } from '@/api/supplier'
import { mapState } from 'vuex'
import { getCaptcha } from '@/api/member'
const clickImg = require('../assets/imgs/click.png')
const editImg = require('../assets/imgs/edit.png')
const bagImg = require('../assets/imgs/bag.png')
const peopleImg = require('../assets/imgs/people.png')
const championImg = require('../assets/imgs/champion.png')
const ruleBackgroundImg = require('../assets/imgs/rules-background.png')
const tagImg = require('../assets/imgs/tag.png')
const trophyImg = require('../assets/imgs/trophy.png')
const shieldImg = require('../assets/imgs/shield.png')
const suitImg = require('../assets/imgs/suit.png')
const platformAdvantageImg = require('../assets/imgs/platform-advantage.png')

export default {
  name: 'SupplierEntry',
  components: { Search },
  data() {
    // 校验邮箱
    const validateEmail = (rule, value, callback) => {
      const reg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/
      if (value && !reg.test(value)) {
        return callback(new Error('邮箱格式不正确'))
      }
      callback()
    }
    return {
      ruleBackgroundImg,
      processList: [
        { text: '了解终端优选', pic: clickImg },
        { text: '在线报名', pic: editImg },
        { text: '考察、洽谈', pic: bagImg },
        { text: '签约合作', pic: peopleImg },
        { text: '成功合作', pic: championImg }
      ],
      platformList: [
        { title: '众多优质供应商/集成商会员', text: '拥有众多精准企业用户，每日完成大批量的行业产品采购交易。', pic: tagImg },
        { title: '严格的会员制度', text: '采用严格的会员制度，且不同等级会员看到的价格略有区别，确保所有目标用户群体均为工程商（不向业主开放，业主无法看到商品批发价），不会影响到传统渠道的价格体系。', pic: trophyImg },
        { title: '雄厚资金实力', text: '终端优选依靠自身及集团公司强大的现金流支持，按协议支付供应商货款，从无任何延迟、拖欠。全场提供增值税专用发票，让您安心、放心。', pic: shieldImg },
        { title: '3 大增值服务', text: '项目信息共享：终端优选地推团队，每月收集数百个项目信息，给到供应商大量项目产品报备的商机。为合作商户提供快捷、极具性价比的资金借贷服务。', pic: suitImg }
      ],
      platformAdvantageImg,
      form: {
        supplierName: '',
        name: '',
        position: '',
        phone: '',
        email: '',
        operationType: '',
        captcha: ''
      },
      rules: {
        supplierName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        operationType: [
          { required: true, message: '请输入经营分类', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' }
        ]
      },
      base64: '', // 图形验证码
      captchaKey: '' // 图形验证码key
    }
  },
  created() {
    this.getCodeImg()
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    // 手机号input事件
    phoneInput(val) {
      this.form.phone = val.replace(/[^\d]/g, '')
    },
    // 实现导航锚点效果
    changeHash(id) {
      document.querySelector(id).scrollIntoView({
        block: 'center'
      })
    },
    async submitForm() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          const params = {
            leaderEmail: this.form.email,
            leaderJob: this.form.position,
            leaderName: this.form.name,
            leaderPhone: this.form.phone,
            businessCategory: this.form.operationType,
            supplierName: this.form.supplierName,
            captchaKey: this.captchaKey,
            captcha: this.form.captcha
          }
          const res = await supplierJoinApi(params)
          if (res.code === 200) {
            this.$Modal.success({
              title: '提示',
              content: '<p>您已成功提交审核，请耐心等待，大约5个工作日内，审核结果会发送到您的预留邮箱。</p>',
              onOk: () => {
                this.$router.push('/')
              }
            })
            this.$refs.form.resetFields()
          } else {
            this.getCodeImg()
          }
        }
      })
    },
    // 获取图形验证码
    async getCodeImg() {
      const res = await getCaptcha()
      this.base64 = res.data.captchaImgData
      this.captchaKey = res.data.key
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  background-color: #F7F7F7;
  padding-bottom: 48px;
}
.placeholder {
  height: 112px;
  width: 100%;
}
.top-banner {
  width: 100%;
  height: 530px;
  background-image: url('../assets/imgs/supplier-banner.png');
  position: relative;
  .top-banner-mask {
    width: 100%;
    height: 100%;
    background-color: rgba(30, 21, 13, 0.5);
    .content {
      padding-top: 109px;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #fff;
      .content-header {
        width: 322px;
        height: 47px;
        text-align: center;
        line-height: 48px;
        border-radius: 4px;
        border: 1px solid #FFFFFF;
        font-size: 18px;
      }
      .platform-name {
        padding-top: 42px;
        font-size: 36px;
        letter-spacing: 6px;
      }
      .platform-intro {
        padding-top: 24px;
        font-size: 50px;
        font-weight: bold;
        letter-spacing: 6px;
      }
      .apply-btn {
        margin-top: 38px;
        width: 200px;
        height: 60px;
        background-color: #F5780C;
        border-color: transparent;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 2px;
        font-weight: 200;
      }
      .el-button:active {
        border-color: #E48A3C;
      }
    }
  }
}
.module {
  width: 1200px;
  margin: 0 auto;
  margin-top: 54px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 28px;
    font-weight: 700;
    line-height: 42px;
    color: #3D3D3D;
  }
  .icon {
    width: 32px;
    height: 30px;
    border: 5px solid #F5780C;
    border-radius: 26px;
    clip-path: polygon(0% 50%, 100% 50%, 100% 3600%, 0% 100%);
    -webkit-clip-path: polygon(0% 50%, 100% 50%, 100% 3600%, 0% 100%);
  }
  .process-content {
    margin-top: 56px;
    width: 100%;
    height: 326px;
    background-color: #FFFFFF;
    display: flex;
    padding: 0 77px;
    justify-content: space-between;
    align-items: center;
    .item {
      text-align: center;
      .img-container {
        width: 130px;
        height: 130px;
        border-radius: 4px;
        background: linear-gradient(180deg, rgba(245, 120, 12, 0.13) 0%, rgba(245, 120, 12, 0.02) 100%);
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 14px;
        .item-img {
          width: 50px;
          height: 50px;
        }
      }
      .item-text {
        line-height: 26px;
        color:#3D3D3D;
        font-size: 16px;
        font-weight: 600;
      }
    }
    .arrow {
      width: 0;
      height: 0;
      border-style: solid;
      border-top-width: 12px;
      border-right-width: 12px;
      border-bottom-width: 12px;
      border-left-width: 15px;
      border-color: transparent transparent transparent #030303;
    }
  }
  .rules-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .rules-item {
      width: 370px;
      height: 370px;
      background-color: #FFFFFF;
      border-radius: 4px;
      position: relative;
      overflow: hidden;
      padding-left: 34px;
      padding-top: 28px;
      .rule-title {
        height: 28px;
        line-height: 28px;
        margin-bottom: 18px;
        color: #3D3D3D;
        font-size: 18px;
        font-weight: 700;
      }
      .rule-row {
        height: 22px;
        margin-bottom: 18px;
        display: flex;
        align-items: center;
        .dot {
          width: 12px;
          height: 12px;
          background-color: #E48A3C;
          border-radius: 50%;
          margin-right: 10px;
        }
        .text {
          font-size: 14px;
          color: #3D3D3D;
        }
      }
      .background-img {
        position: absolute;
        width: 406px;
        height: 94px;
        left: -15px;
        bottom: -15px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
  #main {
    width: 1200px;
    height: 400px;
    display: flex;
    justify-content: center;
    padding-top: 40px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .platform-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 40px;
    .item {
      width: 592px;
      height: 186px;
      padding-left: 35px;
      padding-right: 66px;
      margin-top: 18px;
      background-color: #FFFFFF;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .item-left {
        color: #3D3D3D;
        .item-title {
          font-size: 20px;
          font-weight: bold;
          line-height: 150%;
        }
        .item-text {
          font-size: 14px;
          line-height: 150%;
          margin-top: 16px;
          width: 394px;
        }
      }
    }
    .item:first-child {
      background: linear-gradient(107deg, rgba(235, 147, 71, 0.9437) 12%, rgba(220, 114, 21, 0.88) 87%);
      .item-left {
        color: #FFFFFF;
      }
    }
  }
  .form-content {
    width: 686px;
    height: 560px;
    margin-top: 40px;
    background-color: #FFFFFF;
    padding-top: 48px;
    display: flex;
    flex-direction: column;
    .form-box {
      width: 438px;
      margin: 0 auto;
      /deep/ .el-form-item__label {
        text-align: left;
        color: #3D3D3D;
      }
      /deep/ .el-input__inner:focus {
        border-color: #F5780C;
      }
      .position-item {
        /deep/ .el-form-item__label:before{
          content: '*';
          color: #F56C6C;
          margin-right: 4px;
          visibility: hidden;
        }
      }
    }
    .submit-btn {
      width: 438px;
      margin: 0 auto;
      color: #FFFFFF;
      background-color: #F5780C;
    }
    .el-button:active {
      border-color: #E48A3C;
    }
  }
  .captcha-container {
    display: flex;
    align-items: center;
  }
}
</style>
